{
  "Approve": "承認",
  "DeleteReminder": "リマインダーを削除",
  "DismissAlert": "了解",
  "DismissReminder": "リマインダーを解除",
  "EditReminder": "リマインダーを編集",
  "High": "高",
  "Reject": "拒否",
  "RemindMe15Min": "15 分後に通知",
  "RemindMe5Min": "5 分後に通知",
  "RemindMe60Min": "1 時間後に通知",
  "RemindMeTomorrow": "明日通知",
  "Snooze": "後で通知する",
  "markAsRead": "既読としてマーク",
  "markAsUnread": "未読としてマーク"
}
